module.exports = __webpack_public_path__ + "img/bg.901028b1.png";